import { gql } from '@apollo/client';

/* ── stock research reports ─────────────────────────────────── */

/**
 * Queue the stock research agent for one or more stocks.
 *
 * `window`: "quarterly" writes a full new note, "monthly" updates the latest.
 * `mode`: "batch" runs as batch jobs (cheaper, slower), "sync" as live calls.
 * Returns as soon as the run is queued; `runId` names it.
 */
export const TRIGGER_STOCK_RESEARCH_AGENT = gql`
  mutation TriggerStockResearchAgent(
    $securitySymbols: [String!]!
    $window: String! = "quarterly"
    $mode: String! = "batch"
  ) {
    triggerStockResearchAgent(securitySymbols: $securitySymbols, window: $window, mode: $mode) {
      success
      message
      runId
    }
  }
`;

/** Mark a generated report as reviewed. Answers with a bare boolean. */
export const VERIFY_STOCK_REPORT = gql`
  mutation VerifyStockReport(
    $securitySymbol: String!
    $archetype: String!
    $verified: Boolean!
  ) {
    verifyStockReport(
      securitySymbol: $securitySymbol
      archetype: $archetype
      verified: $verified
    )
  }
`;

